import React, {useCallback} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

import {DATA} from '../constants';
import {useConfirmActions} from '../hooks';

import type {ConfirmTypes} from '../constants';

type Props = {
    confirmType: ConfirmTypes,
    onClose: () => void,
};

export const ConfirmationModal = ({confirmType, onClose}: Props) => {
    const data = DATA[confirmType];
    const {busy, onConfirm} = useConfirmActions();

    const onCloseModal = useCallback(() => {
        if (!busy) {
            onClose();
        }
    }, [busy, onClose]);

    const onConfirmHandler = useCallback(async () => {
        await onConfirm(confirmType);
        onClose();
    }, [confirmType, onClose, onConfirm]);

    return (
        <>
            <DialogHeader onClose={onCloseModal}>
                {data.caption}
            </DialogHeader>
            <DialogMain style={{padding: 24, maxWidth: 400}}>
                {data.content}
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button variant="Type.PRIMARY" busy={busy} onClick={onConfirmHandler}>Yes</Button>
                    <Button variant="Type.SECONDARY" busy={busy} onClick={onCloseModal}>Cancel</Button>
                </Group>
            </DialogFooter>
        </>
    );
};
